import { useCallback } from 'react';
export function useInsertVariableIntoTextField(inputRef, onValueChange) {
  return useCallback(label => {
    var _input$selectionStart, _input$selectionEnd;
    const input = inputRef.current;
    if (!input) return;
    const start = (_input$selectionStart = input.selectionStart) !== null && _input$selectionStart !== void 0 ? _input$selectionStart : input.value.length;
    const end = (_input$selectionEnd = input.selectionEnd) !== null && _input$selectionEnd !== void 0 ? _input$selectionEnd : start;
    const variableText = "{{".concat(label, "}}");
    const newValue = input.value.slice(0, start) + variableText + input.value.slice(end);
    onValueChange(newValue);
    requestAnimationFrame(() => {
      if (!inputRef.current || inputRef.current !== input) return;
      input.focus();
      const cursorPosition = start + variableText.length;
      input.setSelectionRange(cursorPosition, cursorPosition);
    });
  }, [inputRef, onValueChange]);
}